import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AttendanceCard } from '../entities/attendance-card';

@Injectable()
export class AttendanceCardService extends BaseCrudService<AttendanceCard> {

  public uri = '/api/attendanceCard/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance AttendanceCardService');
  }

  buildSentence(entity?: AttendanceCard, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isCurrent ?
          `isCurrent${QueryOperator.Equal}${entity.isCurrent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.issueDate ?
          `issueDate${QueryOperator.Equal}${entity.issueDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
          `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isManager ?
          `isManager${QueryOperator.Equal}${entity.isManager}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id==undefined) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${0}${QueryOperator.Split}`
        );
      }
      if (entity.shift && entity.shift.id) {
        query = query.concat(
          `shift.id${QueryOperator.Equal}${entity.shift.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/attendance-card.service.ts